module.exports = __webpack_public_path__ + "img/Coupe_Side_Left.968f8a2d.svg";